import { EventContact } from '../../api/models/event-contact';
import { DynamicRecipientKind } from '../../shared/dynamic-recipients';

export enum enumWorkflowType {
  ORDER = 1,
  TICKET = 2,
  CUSTOMER_ORDER = 3,
  DELIVERY = 4,
  DDT = 5,
}

export enum enumWorkflowTransitionEventType {
  EMAIL = 'email',
  // Richiede una nota integrazione nel cambio stato (solo workflow dei ticket)
  INTEGRATION_NOTE = 'integration_note',
}

export interface WorkflowTransitionEvent {
  type: enumWorkflowTransitionEventType;
  config: any; // JSON
}

export interface WorkflowTransitionEmailEvent {
  type: enumWorkflowTransitionEventType.EMAIL;
  config: {
    subject: string;
    body: string;
    to: {
      to: number[];
      cc: number[];
      bcc: number[];
      to_dynamic?: DynamicRecipientKind[];
      cc_dynamic?: DynamicRecipientKind[];
      bcc_dynamic?: DynamicRecipientKind[];
    }[];
  }; // JSON
}

export interface WorkflowTransitionIntegrationNoteEvent {
  type: enumWorkflowTransitionEventType.INTEGRATION_NOTE;
  config: { required: boolean };
}

export interface WorkflowTransitionEditEvent {
  type: enumWorkflowTransitionEventType;
  config: any; // JSON
}

export interface WorkflowTransitionEmailEditEvent {
  type: enumWorkflowTransitionEventType.EMAIL;
  config: {
    subject: string;
    body: string;
    attachments: String[];
    to: {
      to: EventContact[];
      cc: EventContact[];
      bcc: EventContact[];
      to_dynamic?: DynamicRecipientKind[];
      cc_dynamic?: DynamicRecipientKind[];
      bcc_dynamic?: DynamicRecipientKind[];
    }[];
  }; // JSON
}

export interface WorkFlowTransition {
  from?: number;
  to: number;
  next?: WorkFlowTransition[];
  events?: (
    | WorkflowTransitionEvent
    | WorkflowTransitionEmailEvent
    | WorkflowTransitionIntegrationNoteEvent
  )[];
  constraints?: any; // non utilizzato ma previsto
}

export interface WorkFlow {
  name: string;
  description: string;
  type_id: enumWorkflowType;
  config: WorkFlowTransition;
}

export interface Status {
  id: number;
  label: string;
}

export interface StatusNode {
  id: number;
  label: string;
  children?: StatusNode[];
}
